import { render, staticRenderFns } from "./SupplyManager.vue?vue&type=template&id=4bf2932a&"
import script from "./SupplyManager.vue?vue&type=script&lang=js&"
export * from "./SupplyManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports